const DocumentType = {
    invoice: 0,
    receipt: 1,
    payInOrder: 2,
};

export default DocumentType;
